var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleLogo = function SvgGoogleLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M23.766 12.776c0-.815-.066-1.635-.207-2.438H12.24v4.621h6.482a5.55 5.55 0 0 1-2.399 3.647v2.998h3.867c2.27-2.09 3.576-5.177 3.576-8.828"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M12.24 24.5c3.236 0 5.966-1.062 7.954-2.896l-3.867-2.998c-1.075.731-2.464 1.146-4.083 1.146-3.13 0-5.785-2.112-6.737-4.952h-3.99v3.091a12 12 0 0 0 10.723 6.61"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M5.503 14.8a7.2 7.2 0 0 1 0-4.594V7.115H1.516a12.01 12.01 0 0 0 0 10.776z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M12.24 5.25a6.52 6.52 0 0 1 4.603 1.799l3.426-3.426A11.53 11.53 0 0 0 12.24.5 12 12 0 0 0 1.516 7.115l3.987 3.09C6.45 7.363 9.109 5.25 12.24 5.25"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "google-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h24v24H0z"
  })))));
};
export default SvgGoogleLogo;